/*import React, { useEffect, useState } from 'react';
import axios from 'axios';

function FarmMap() {
  const [farmLocations, setFarmLocations] = useState([]);

  useEffect(() => {
    fetchFarmLocations();
  }, []);

  const fetchFarmLocations = async () => {
    try {
      const response = await axios.get('http://vicenterc-001-site35.etempurl.com/API/D_MapView.php');
      setFarmLocations(response.data);
    } catch (error) {
      console.error('Failed to fetch farm locations:', error);
    }
  };

  useEffect(() => {
    if (farmLocations.length > 0) {
      initMap();
    }
  }, [farmLocations]);

  const initMap = () => {
    // Create a new map centered on a specific location (e.g., first farm location)
    const map = new window.google.maps.Map(document.getElementById('map'), {
      zoom: 8,
      center: new window.google.maps.LatLng(
        farmLocations[0].latitude,
        farmLocations[0].longitude
      ),
    });

    // Define custom icons for station and car
    const stationIcon = {
      url: 'dist/img/fffficon.png', // Replace with the URL of your station icon image
      scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
    };

    const carIcon = {
      url: 'dist/img/cccincon.png', // Replace with the URL of your car icon image
      scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
    };

    // Add markers for each farm location with the respective icon and title
    farmLocations.forEach((location) => {
      const icon = location.type === 'station' ? stationIcon : carIcon;
      const marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(
          location.latitude,
          location.longitude
        ),
        map: map,
        icon: icon,
      });

      //const title = location.type === 'station' ? 'Station Number: ' + location.id : 'Car Number: ' + location.id;
      const title = location.type === 'station' ? `Station: ${location.stationname}` : `Car: ${location.id}`;
const latLngText = `Latitude: ${location.latitude}, Longitude: ${location.longitude}`;
const fuelLevelText = location.fuellevel ? `Fuel Level (Litres): ${location.fuellevel}` : '';

const infoWindow = new window.google.maps.InfoWindow({
  content: `
    <div style="color: black;">
      <div>${title}</div>
      <div>${latLngText}</div>
      <div>${fuelLevelText}</div>
    </div>
        `,
      });

      marker.addListener('click', () => {
        infoWindow.open(map, marker);
      });
    });

    // Add lines between the farm locations
    const lineCoordinates = farmLocations.map((location) => ({
      lat: location.latitude,
      lng: location.longitude,
    }));

    const line = new window.google.maps.Polyline({
      path: lineCoordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });

    line.setMap(map);
  };

  return (
    <div id="map" style={{ height: '400px', width: '105%', margin: '-25px' }}></div>
  );
}

export default FarmMap;
*/

import React, { useEffect, useState } from 'react';
import axios from 'axios';

function FarmMap() {
  const [farmLocations, setFarmLocations] = useState([]);
  const [map, setMap] = useState(null);

  useEffect(() => {
    fetchFarmLocations();
    const interval = setInterval(fetchFarmLocations, 5000); // Fetch data every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const fetchFarmLocations = async () => {
    try {
      const response = await axios.get('http://vicenterc-001-site35.etempurl.com/API/D_MapView.php');
      setFarmLocations(response.data);
    } catch (error) {
      console.error('Failed to fetch farm locations:', error);
    }
  };

  useEffect(() => {
    if (farmLocations.length > 0) {
      if (!map) {
        initMap();
      } else {
        updateMap();
      }
    }
  }, [farmLocations]);

  const initMap = () => {
    const newMap = new window.google.maps.Map(document.getElementById('map'), {
      zoom: 8,
      center: new window.google.maps.LatLng(
        farmLocations[0].latitude,
        farmLocations[0].longitude
      ),
    });
    setMap(newMap);
    updateMap(newMap);
  };

  const updateMap = (mapInstance) => {
    const currentMap = mapInstance || map;

    // Define custom icons for station and car
    const stationIcon = {
      url: 'dist/img/fffficon.png', // Replace with the URL of your station icon image
      scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
    };

    const carIcon = {
      url: 'dist/img/cccincon.png', // Replace with the URL of your car icon image
      scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
    };

    // Clear existing markers and lines
    currentMap.markers?.forEach(marker => marker.setMap(null));
    currentMap.lines?.forEach(line => line.setMap(null));

    currentMap.markers = [];
    currentMap.lines = [];

    // Add markers for each farm location with the respective icon and title
    farmLocations.forEach((location) => {
      const icon = location.type === 'station' ? stationIcon : carIcon;
      const marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(
          location.latitude,
          location.longitude
        ),
        map: currentMap,
        icon: icon,
      });

      const title = location.type === 'station' ? `Station: ${location.stationname}` : `Car: ${location.id}`;
      const latLngText = `Latitude: ${location.latitude}, Longitude: ${location.longitude}`;
      const fuelLevelText = location.fuellevel ? `Fuel Level (Litres): ${location.fuellevel}` : '';

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="color: black;">
            <div>${title}</div>
            <div>${latLngText}</div>
            <div>${fuelLevelText}</div>
          </div>
        `,
      });

      marker.addListener('click', () => {
        infoWindow.open(currentMap, marker);
      });

      currentMap.markers.push(marker);
    });

    // Add lines between the farm locations
    const lineCoordinates = farmLocations.map((location) => ({
      lat: location.latitude,
      lng: location.longitude,
    }));

    const line = new window.google.maps.Polyline({
      path: lineCoordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });

    line.setMap(currentMap);
    currentMap.lines.push(line);
  };

  return (
    <div id="map" style={{ height: '400px', width: '105%', margin: '-25px' }}></div>
  );
}

export default FarmMap;
